var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeatherRain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62073 1V0H9.62065L9.62073 1ZM14.3444 3.5L13.4988 4.03383C13.682 4.32402 14.0012 4.5 14.3444 4.5V3.5ZM15.4166 3.5L15.4166 2.5H15.4166V3.5ZM15.4166 11V12V11ZM9.27991 11L9.27981 12H9.27991V11ZM7.99768 10.7744L8.33973 9.83473C8.31746 9.82663 8.29492 9.81932 8.27214 9.81282L7.99768 10.7744ZM9.62073 1V2C11.3088 2 12.7454 2.84047 13.4988 4.03383L14.3444 3.5L15.19 2.96617C14.0569 1.17134 11.9699 0 9.62073 0V1ZM14.3444 3.5V4.5H15.4166V3.5V2.5H14.3444V3.5ZM15.4166 3.5L15.4166 4.5C16.9354 4.5 18.1666 5.73122 18.1666 7.25H19.1666H20.1666C20.1666 4.62665 18.04 2.5 15.4166 2.5L15.4166 3.5ZM19.1666 7.25H18.1666C18.1666 8.76878 16.9354 10 15.4166 10V11V12C18.04 12 20.1666 9.87335 20.1666 7.25H19.1666ZM15.4166 11V10H9.27991V11V12H15.4166V11ZM9.27991 11L9.28 10C8.94862 9.99997 8.63252 9.94131 8.33973 9.83473L7.99768 10.7744L7.65563 11.7141C8.16302 11.8988 8.71033 11.9999 9.27981 12L9.27991 11ZM7.99768 10.7744L8.27214 9.81282C6.41969 9.28409 5.16663 7.73491 5.16663 6H4.16663H3.16663C3.16663 8.75134 5.13655 10.9977 7.72322 11.736L7.99768 10.7744ZM4.16663 6H5.16663C5.16663 3.87109 7.07712 2.00019 9.6208 2L9.62073 1L9.62065 0C6.13982 0.000254393 3.16663 2.60633 3.16663 6H4.16663Z",
    fill: "black",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5096 11.3982L11.0757 13.4461",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6741 11.2623L14.7622 13.9928",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34518 11.5342L5.47729 15.6299",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16365 16.1766L8.68567 16.8592",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01402 10.0035L3.58008 12.0513",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRain);
export default __webpack_public_path__ + "static/media/Weather Rain.b47ec5da9a0dbc57dd467b4034ff3fca.svg";
export { ForwardRef as ReactComponent };